<template>
  <div class="ts-app-shell_fh">
    <div class="ts-app-landing-dashboard">
      <div class="padd-main">
        <div class="ts-app-shell--header">
          <h5>
            <strong>See Companies who reached out</strong>
          </h5>
          <div class="ts-app-shell--header_actions flexed">
          </div>
        </div>
        <el-row class="dashboard-information">
          <el-col>
            <span style="font-size:15px;">
              This is your dashboard where you can manage the process of seeking and potentially finding your next opportunity.  Use TalentSens<i style="color:#00C8DC">us</i> to help you take control of your future!
            </span>
          </el-col>  
        </el-row>
        <el-row style="border-bottom: 1px solid #C0C0C0">
          <el-col>
            <p>
              <i class="fa fa-check-circle" style="color: #00C8DC;visibility: hidden"></i> <br>
              <i class="fa fa-check-circle" style="color: #00C8DC"></i> View which companies have extended interest based on a Skills Match to an apprenticeship role they have <br>
              <i class="fa fa-check-circle" style="color: #00C8DC"></i> Manage and view all the companies who have selected you to meet for an appointment <br>
              <i class="fa fa-check-circle" style="color: #00C8DC"></i> Be notified when a company has selected to send you notice to discuss an offer of apprenticeship <br>
            </p>
          </el-col>
        </el-row>
        <el-row :gutter="25">
          <el-col :xl="5" :lg="5" :md="5">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <div class="card-body" @click="openStatusPage('reachedout')">
                <h6 class="card-font">Companies Who <br>Reached Out</h6>
                <div class="dash-card">
                  <i class="fas fa-handshake"></i>
                </div>                        
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button">View</el-button>
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12">
            <el-row>
               <el-col>
                  <el-row style="margin-top:25px" class="dashboard-information">
                    <el-col>
                      <h6>
                        Companies with Interest 
                      </h6>
                    </el-col>
                  </el-row>
                  <el-row class="dashboard-information">
                    <el-col>
                      <p>
                        Access a list of companies who have outreached to you to let you know that they are interested in discussing the apprenticeship role with you based on a Skills Match of what they are looking for and your Skills Profile
                      </p>
                    </el-col>
                  </el-row>
               </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="25">
          <el-col :xl="5" :lg="5" :md="5">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <div class="card-body" @click="openStatusPage('connected')">
                <h6 class="card-font">Confirmed <br>Appointments</h6>
                <div class="dash-card">
                  <i class="fa fa-list"></i>
                </div>                        
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button">View</el-button>
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12">
            <el-row>
               <el-col>
                  <el-row style="margin-top:25px" class="dashboard-information">
                    <el-col>
                      <h6>
                        Companies with Scheduled Appointments
                      </h6>
                    </el-col>
                  </el-row>
                  <el-row class="dashboard-information">
                    <el-col>
                      <p>
                        Review and manage the list of those companies who have scheduled an appointment/interview with you to further discuss the position and recruitment process
                      </p>
                    </el-col>
                  </el-row>
               </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="25">
          <el-col :xl="5" :lg="5" :md="5">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <div class="card-body" @click="openStatusPage('offersent')">
                <h6 class="card-font">Job Offers</h6>
                <div class="dash-card">
                  <i class="fas fa-envelope"></i>
                </div>                        
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button">View</el-button>
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12">
            <el-row>
               <el-col>
                  <el-row style="margin-top:25px" class="dashboard-information">
                    <el-col>
                      <h6>
                        Job Offers 
                      </h6>
                    </el-col>
                  </el-row>
                  <el-row class="dashboard-information">
                    <el-col>
                      <p>
                        Congratulations! Check notifications to view when a company has decided
                        they would like to extend an offer of apprenticeship.  It’s a match!!!
                      </p>
                    </el-col>
                  </el-row>
               </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    openStatusPage(tab) {
      this.$router.push({ name: 'InterestedCompaniesStatusboard', params: { status: tab }});
    },
  }
}
</script>
<style lang="scss">
  @import '../../../../assets/scss/project/dashboard.scss';
</style>
